<template>
  <div class="workbench-container cso-cockpit">
    <div class="workbench-body">
      <CsoHeaderCard />
      <div class="workbench">
        <div class="brief-grid">
          <div class="brief-grid-item">
            <EnterpriseWarRoom
              :agent-id="agentId"
              @open-detail="$emit('open-detail', $event)"
              @open-list="$emit('open-list')"
              @smart-analysis="$emit('smart-analysis', $event)"
              @start-chat="$emit('start-chat', $event)"
            />
          </div>
          <div class="brief-grid-item">
            <TaskQueue
              @open-detail="(taskData) => $emit('task-open-detail', taskData)"
              @open-list="$emit('task-open-list')"
            />
          </div>
          <div class="brief-grid-item">
            <PendingDecisions
              @smart-analysis="$emit('smart-analysis', $event)"
              @open-detail="$emit('decision-open-detail', $event)"
              @open-list="$emit('decision-open-list')"
            />
          </div>
        </div>
        <!-- <div class="flex-container gap-10">
        <div class="flex-item-2">
          <EnterpriseWarRoom
            :agent-id="agentId"
            @open-detail="$emit('open-detail', $event)"
            @open-list="$emit('open-list')"
            @smart-analysis="$emit('smart-analysis', $event)"
            @start-chat="$emit('start-chat', $event)"
          />
        </div>
        <div class="flex-item">
          <TaskQueue
            :agent-id="agentId"
            @open-detail="(taskData) => $emit('task-open-detail', taskData)"
            @open-list="$emit('task-open-list')"
          />
        </div>
      </div> -->
        <CsoCoreIndicators
          :dashboard-data="dashboardData"
          :dashboard-loading="dashboardLoading"
          @smart-analysis="$emit('smart-analysis', $event)"
        />
        <div class="analysis-grid">
          <CsoProcurementCost
            v-if="dashboardLoading || hasRegionData(REGION.PROCUREMENT_COST)"
            :dashboard-data="dashboardData"
            :dashboard-loading="dashboardLoading"
          />
          <CsoCoreKpi
            v-if="dashboardLoading || hasRegionData(REGION.CORE_KPI)"
            :dashboard-data="dashboardData"
            :dashboard-loading="dashboardLoading"
          />
          <CsoStrategyProgress
            v-if="dashboardLoading || hasRegionData(REGION.STRATEGY_PROGRESS)"
            :dashboard-data="dashboardData"
            :dashboard-loading="dashboardLoading"
          />
        </div>
        <CsoSankeyChart
          @smart-analysis="$emit('smart-analysis', $event)"
          @open-price-management="$emit('open-price-management')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CsoHeaderCard from './components/CsoHeaderCard.vue'
import EnterpriseWarRoom from '../components/EnterpriseCard.vue'
import TaskQueue from '../components/TaskQueue.vue'
import PendingDecisions from '../components/PendingDecisions.vue'
import CsoCoreIndicators from './components/CsoCoreIndicators.vue'
import CsoProcurementCost from './components/CsoProcurementCost.vue'
import CsoCoreKpi from './components/CsoCoreKpi.vue'
import CsoStrategyProgress from './components/CsoStrategyProgress.vue'
import CsoSankeyChart from './components/CsoSankeyChart.vue'
import { getSupplyChainDashboard } from '@/api/supply-chain'
import { AGENT_ID_MAP } from '@/store/modules/cosmoClaw'
import { REGION, groupByRegion } from './utils/externalMetrics'

export default {
  name: 'CsoWorkbench',
  components: {
    CsoHeaderCard,
    EnterpriseWarRoom,
    TaskQueue,
    PendingDecisions,
    CsoCoreIndicators,
    CsoProcurementCost,
    CsoCoreKpi,
    CsoStrategyProgress,
    CsoSankeyChart
  },
  data() {
    return {
      agentId: AGENT_ID_MAP.gong_ying_lian_shu_zi_ren,
      dashboardData: {},
      dashboardLoading: true
    }
  },
  computed: {
    // 供模板引用 REGION 常量
    REGION() {
      return REGION
    }
  },
  created() {
    this.fetchDashboard()
  },
  methods: {
    // 某 region 是否有有效数据（用于三面板按数据惰性显隐；loading 期由模板保留骨架）
    hasRegionData(region) {
      const ext = this.dashboardData && this.dashboardData.externalMetrics
      if (!ext || !Array.isArray(ext.data)) return false
      return (groupByRegion(ext.data)[region] || []).length > 0
    },
    async fetchDashboard() {
      this.dashboardLoading = true
      try {
        const res = await getSupplyChainDashboard()
        this.dashboardData = res && res.data ? res.data : {}
      } catch (error) {
        console.error('获取供应链驾驶舱数据失败:', error)
      } finally {
        this.dashboardLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles/cso-cockpit.scss";

.workbench-container {
  height: 100%;
  padding: 24px;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.workbench-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.workbench {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #fff transparent;
  box-sizing: border-box;
}
.workbench::-webkit-scrollbar {
  width: 4px;
}
.workbench::-webkit-scrollbar-track {
  background: transparent;
}
.workbench::-webkit-scrollbar-thumb {
  background: #fff;
  border-radius: 2px;
}

.brief-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  width: 100%;
  min-width: 700px;
  flex-shrink: 0;
}

.brief-grid-item {
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
}

.analysis-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.12fr) minmax(0, 1fr);
  gap: 10px;
  width: 100%;
  min-width: 700px;
  flex-shrink: 0;
  align-items: stretch;
  grid-auto-rows: minmax(250px, auto);
}

.analysis-grid > .cso-panel {
  height: 100%;
  min-width: 0;
}

.grid-1 {
  width: 100%;
  min-width: 700px;
}

.gap-10 {
  gap: 10px;
}
.flex-container {
  width: 100%;
  min-width: 700px;
  display: flex;
}
.flex-item {
  width: calc((100% - 10px) / 3);
  flex-shrink: 1;
  min-width: 0;
}
.flex-item-2 {
  width: calc((100% - 10px) / 3 * 2);
  flex-shrink: 1;
  min-width: 0;
}
.gap-10 {
  gap: 10px;
}
</style>
